import RatingCard from './RatingCard';

// export { TextProps } from './RatingCard';
export default RatingCard;
